import { useState, useEffect, useCallback, useRef } from "react";
import ApiUrl from "../config/app-config";
import axios from "axios";

const baseURL = ApiUrl();

function useInfinite({ url, listSize }) {
  const [data, setData] = useState([]);

  // 최신 값 보관용 ref
  const loadingRef = useRef(false);
  const pageIndexRef = useRef(1);
  const dataLengthRef = useRef(0);
  const totalCntRef = useRef(0);

  // 공지사항 데이터 호출 함수
  const fetchData = useCallback(
    async (page, append = false) => {
      if (loadingRef.current) {
        return;
      }
      loadingRef.current = true;

      try {
        const response = await axios.get(`${baseURL}${url}`, {
          params: {
            listSize,
            currentPageIndex: page,
          },
        });
        const { result, totalListCount } = response.data;

        totalCntRef.current = totalListCount;
        pageIndexRef.current = page;

        setData((prev) => {
          const newData = append ? [...prev, ...result] : result;
          dataLengthRef.current = newData.length;
          return newData;
        });
      } catch (error) {
        console.error(error);
      } finally {
        loadingRef.current = false;
      }
    },
    [url, listSize]
  );

  // 최초 로딩
  useEffect(() => {
    fetchData(1, false);
  }, [fetchData]);

  // 스크롤 이벤트
  useEffect(() => {
    const handleScroll = () => {
      const isBottom =
        window.innerHeight + window.scrollY >= document.body.offsetHeight;

      if (
        isBottom &&
        dataLengthRef.current < totalCntRef.current &&
        !loadingRef.current
      ) {
        fetchData(pageIndexRef.current + 1, true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [fetchData]);

  return data;
}

export default useInfinite;
